module.exports = __webpack_public_path__ + "static/media/3.61d29bb1.jpg";